(async () => {
    var t = await import(window.theme.modules.baseComponent);
    customElements.define("main-nav", class extends t.default {
        elements = {
            dropdowns: "*[data-dropdown]",
            dropdowns_wrapper: "*[data-dropdown-wrapper]"
        };
        modalInit = !1;
        render() {
            this.$dropdowns.filter(t => t.hasAttribute("data-offset-drop")).map(t => {
                var e = t.getBoundingClientRect();
                document.documentElement.clientWidth - e.x + e.width < 600 && t.classList.add("@drop-reverse")
            }
            )


            var menuItems = this.$dropdowns_wrapper;
            var hi = new SV.HoverIntent(menuItems, {
                // required parameters
                onEnter: function (targetItem) {
                    targetItem.classList.add('visible');
                },
                onExit: function (targetItem) {
                    targetItem.classList.remove('visible');
                },

                // default options
                exitDelay: 300,
                interval: 100,
                sensitivity: 6,
            });

        }
        reRender() {
            this.closest("modal-popup") && !this.modalInit && (this.modalInit = !0,
                this.$dropdowns.map(t => {
                    t.addEventListener("click", t => {
                        t.preventDefault();
                        t = t.currentTarget.dataset.dropdown;
                        const e = this.querySelector(`[data-dropby="${t}"]`);
                        e.classList.toggle("!active")
                    }
                    )
                }
                ))
        }
    }
    )



}
)();
document.querySelectorAll('.submenu-toggler').forEach(function (toggler) {
    toggler.addEventListener('click', function (event) {
        event.preventDefault();
        const ulElement = this.parentElement.querySelector('.submenu-level-2');
        if (ulElement) {
            ulElement.classList.toggle('active');
        }
    });
});



jQuery(document).ready(function ($) {

    $('.main-nav-item').each(function () {
        const $menuItem = $(this);

        $menuItem.on('mouseenter', function () {
            setTimeout(() => {
                if ($menuItem.hasClass('visible')) {
                    $menuItem.find('ul li a').removeAttr('tabindex');
                }
            }, 400);
        });

        $menuItem.on('mouseleave', function () {
            $menuItem.find('ul li a').attr('tabindex', '-1');
        });
    });

});
